import { LOCALE_DIRECTION, isLocale, type Locale } from './locale-list';

export type Direction = 'ltr' | 'rtl';

export function getDirection(locale: string): Direction {
  if (isLocale(locale)) return LOCALE_DIRECTION[locale];
  return 'ltr';
}

export function isRtl(locale: string): boolean {
  return getDirection(locale) === 'rtl';
}

export function oppositeDirection(direction: Direction): Direction {
  return direction === 'ltr' ? 'rtl' : 'ltr';
}

export type { Locale };
